<script setup lang="ts">
import { computed, provide, ref } from "vue";
import { useRoute } from "vue-router";
import { useDisplay } from "vuetify";
import NavBar from "@/components/shared/navbar/Navbar.vue";
import VersionChecker from "@/components/shared/VersionChecker.vue";
import ChatDock from "@/components/models/message/chatDock/ChatDock.vue";
import ChatDockMobileDrawer from "@/components/models/message/chatDock/ChatDockMobileDrawer.vue";
import { openMobileChatDockKey } from "@/composables/models/message/openMobileChatDock.ts";

const route = useRoute();
const { mdAndUp, lgAndDown } = useDisplay();
const isRoomsRoute = computed(() => route.path.startsWith("/rooms"));
const isRoomsIndex = computed(() => route.path === "/rooms" || route.path === "/rooms/");

const mobileChatDockOpen = ref(false);
provide(openMobileChatDockKey, () => {
  mobileChatDockOpen.value = true;
});
</script>

<template>
  <v-layout>
    <nav-bar fullscreen />
    <chat-dock-mobile-drawer
      v-if="isRoomsRoute && lgAndDown"
      v-model="mobileChatDockOpen"
      :extend="isRoomsIndex"
    />
    <v-main
      class="tw:!flex tw:flex-col tw:h-dvh tw:!pb-0 tw:bg-on-background tw:dark:bg-surface-muted"
    >
      <v-container
        class="tw:flex tw:flex-col tw:!max-w-full tw:h-full tw:grow-1 tw:!p-0 tw:md:!pt-1 tw:md:!pl-2"
      >
        <VersionChecker class="tw:shrink-0" />
        <div class="tw:flex tw:min-h-0 tw:flex-1 tw:overflow-hidden">
          <chat-dock
            v-if="isRoomsRoute && mdAndUp"
            sticky
            :extend="isRoomsIndex"
          />
          <router-view />
        </div>
      </v-container>
    </v-main>
  </v-layout>
</template>

<style scoped></style>
